<template>
  <div class="content">
    <div class="back-container">
      <button
        v-if="
          ['Active', 'Pending'].includes(subscription.status) ||
            ['agency', 'family'].includes(user.plan)
        "
        @click="submitting ? 0 : $emit('close')"
      >
        <ChevronDownIcon />
        Back to Billing
      </button>
    </div>
    <div class="billing">
      <div class="artist">
        <div class="avatar">
          <img :src="artist.avatar_url" alt="" />
        </div>
        <div class="name">{{ mainMessage }}</div>
      </div>
      <div
        v-if="bannerMessage"
        class="mt-8 banner-alert"
        :class="bannerType == 'error' ? 'banner-alert--error' : null"
      >
        <div class="text">
          <div class="title">
            <i class="fa fa-exclamation-circle"></i>
            {{ bannerMessage }}
          </div>
        </div>
      </div>
      <div class="billing-card">
        <div class="card-top">
          <span class="card-title">Payment Method</span>
          <!-- <p class="card-text">
            Your default method is charged once a month for all active
            subscriptions.
          </p> -->
        </div>
        <div class="card-content">
          <div class="braintree-billing">
            <template>
              <div class="payment-container">
                <div id="dropin-container-updated"></div>
                <div class="payment-footer">
                  <!-- <button
                      v-if="paymentButtonActive && !isTrial"
                      @click.prevent="onSuccessBillingUpdate"
                      class="button-default big"
                      :disabled="saving || paymentButtonDisabled"
                    >
                      <span>
                        {{ paymentButtonText }}
                      </span>
                    </button> -->
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="pb-5 card-top">
          <span class="card-title">Plan</span>
        </div>
        <!-- v-if="showSubscriptionDetails && !(isAgency || isFamily)" -->
        <ul class="grid grid-cols-3 gap-4 pb-6">
          <li
            v-for="(plan, i) in availablePlans"
            :key="'plan-' + i"
            class="relative plan-selector font-montserrat ring-1"
            :class="plan.name == newPlan ? '  ring-dark-purple' : 'ring-white'"
            @click="selectPlan(plan.name)"
          >
            <div
              class="absolute top-0 right-0 inline-flex items-center px-2 py-1 m-3 text-xs font-medium rounded-full ring-1 ring-inset ring-lilac"
              v-if="artist.active_plan.includes(plan.name)"
            >
              Current
            </div>
            <span class="pb-2 font-semibold capitalize title font-montserrat">{{
              plan.name
            }}</span>
            <span class="subtitle font-montserrat">
              ${{
                new_billing_interval == "monthly"
                  ? plan.priceMonthly
                  : plan.priceYearly
              }}
              per {{ new_billing_interval == "monthly" ? "Month" : "Year" }}
            </span>
            <span
              style="height: 1px;"
              class="w-full my-5 bg-purple-stroke"
            ></span>
            <ul class="flex flex-col w-full gap-4 ">
              <li
                class="flex items-center px-6 justify-start  gap-1.5 text-sm font-semibold text-lilac"
                v-for="(feature, j) in plan.features"
                :key="j"
              >
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.7099 7.69814C18.617 7.60441 18.5064 7.53002 18.3845 7.47925C18.2627 7.42848 18.132 7.40234 17.9999 7.40234C17.8679 7.40234 17.7372 7.42848 17.6154 7.47925C17.4935 7.53002 17.3829 7.60441 17.29 7.69814L9.83995 15.1581L6.70995 12.0181C6.61343 11.9249 6.49949 11.8516 6.37463 11.8024C6.24978 11.7532 6.11645 11.7291 5.98227 11.7314C5.84809 11.7337 5.71568 11.7624 5.5926 11.8159C5.46953 11.8694 5.35819 11.9466 5.26495 12.0431C5.17171 12.1397 5.0984 12.2536 5.04919 12.3785C4.99999 12.5033 4.97586 12.6366 4.97818 12.7708C4.9805 12.905 5.00923 13.0374 5.06272 13.1605C5.11622 13.2836 5.19343 13.3949 5.28995 13.4881L9.12995 17.3281C9.22291 17.4219 9.33351 17.4963 9.45537 17.547C9.57723 17.5978 9.70794 17.6239 9.83995 17.6239C9.97196 17.6239 10.1027 17.5978 10.2245 17.547C10.3464 17.4963 10.457 17.4219 10.55 17.3281L18.7099 9.16814C18.8115 9.0745 18.8925 8.96085 18.9479 8.83435C19.0033 8.70785 19.0319 8.57124 19.0319 8.43314C19.0319 8.29504 19.0033 8.15844 18.9479 8.03194C18.8925 7.90544 18.8115 7.79178 18.7099 7.69814Z"
                    fill="#B1AFCD"
                  />
                </svg>
                <span
                  class="font-montserrat"
                  :class="i > 0 && j == 0 ? 'font-extrabold' : null"
                >
                  {{ feature }}</span
                >
              </li>
            </ul>
          </li>
        </ul>
        <!-- v-if="(showSubscriptionDetails && !(isAgency || isFamily)) || isTrial" -->

        <div class="pb-5 card-top">
          <span class="card-title">Billing Interval</span>
        </div>
        <!-- v-if="showSubscriptionDetails && !(isAgency || isFamily)" -->
        <div class="billing-interval trial">
          <div
            class="relative element"
            :class="{ selected: 'monthly' === new_billing_interval }"
            @click="new_billing_interval = 'monthly'"
          >
            <div
              class="absolute top-0 right-0 inline-flex items-center px-2 py-1 m-3 text-xs font-medium rounded-full ring-1 ring-inset ring-lilac"
              v-if="subscription.billing_interval == 'monthly'"
            >
              Current
            </div>
            <span class="title">{{ billing_intervals.monthly }}</span>
            <span class="subtitle mt-1.5">
              ${{ totalForThisArtist.monthly }} Per Month
            </span>
          </div>
          <div
            class="relative element"
            :class="{ selected: 'yearly' === new_billing_interval }"
            @click="new_billing_interval = 'yearly'"
          >
            <div
              class="absolute top-0 right-0 inline-flex items-center px-2 py-1 m-3 text-xs font-medium rounded-full ring-1 ring-inset ring-lilac"
              v-if="subscription.billing_interval == 'yearly'"
            >
              Current
            </div>
            <span class="title">
              {{ billing_intervals.yearly }} (${{ yearlyDiscount }} Discount)
            </span>
            <span class="subtitle mt-1.5">
              ${{ totalForThisArtist.yearly }} per Year
            </span>
          </div>
        </div>

        <!-- <div
          v-if="nextBillingDate"
          class="flex items-center justify-between w-full p-6 mt-4 rounded-ah bg-purple-background"
        >
          <span class="font-semibold text-white">Next Billing Date</span>
          <span class="font-semibold text-white">
            {{ nextBillingDate }}
          </span>
        </div> -->

        <!-- // !planUpdated
              // ? "$0"
              // : -->

        <div class="flex items-center justify-end gap-6 mt-6">
          <div class="flex flex-col items-end justify-start gap-1">
            <span class="text-sm font-bold text-lilac">Due now</span>
            <span class="font-semibold text-white">{{
              prorationAmount > 0
                ? "$" + prorationAmount + "(Prorated)"
                : "$" + totalAmount
            }}</span>
          </div>
          <button
            :disabled="submitting || !planUpdated"
            @click="updateArtistPlan(newPlan)"
            class="button-default big"
          >
            <span>
              {{ submitting ? "Loading..." : "Continue" }}
            </span>
          </button>
        </div>
        <!-- <div class="billing-interval trial" v-else-if="isTrial">
          <div
            class="element"
            :class="{ selected: 'monthly' === new_billing_interval }"
            @click="new_billing_interval = 'monthly'"
          >
            <span class="title">{{ billing_intervals.monthly }}</span>
            <span class="subtitle"> ${{ total.monthly }} </span>
          </div>
          <div
            class="element"
            :class="{ selected: 'yearly' === new_billing_interval }"
            @click="new_billing_interval = 'yearly'"
          >
            <span class="title">
              {{ billing_intervals.yearly }} / ${{ yearlyDiscountTrial }}
              Discount
            </span>
            <span class="subtitle"> ${{ total.yearly }} </span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ChevronDownIcon from "../../../public/img/icons/chevron-down.svg";
import {
  // Q_PRO_PRICING,
  M_BRAINTREE_CLIENT_TOKEN,
  M_BRAINTREE_SUBSCRIBE,
  // M_BRAINTREE_CHANGE_ARTIST_PLAN,
  // M_UPDATE_AGENCY_ARTIST_PLAN,
  M_BRAINTREE_CHANGE_BILLING_INTERVAL
} from "@/graphql";
import moment from "moment";
import dropin from "braintree-web-drop-in";
import Swal from "sweetalert2";

export default {
  props: ["user", "artist", "subscription", "subscribing", "actionType"],
  data() {
    return {
      mainMessageList: {
        activate_sub: "Activate your subscription",
        trial_expired: "Your trial expired",
        restore_artist: "Restore your artist",
        account_past_due: "Your account is past due"
      },
      bannerMessageList: {
        activate_sub: {
          message:
            "Please add a payment method to prevent your links and data from getting disabled.",
          type: "info"
        },
        trial_expired: {
          message:
            "Please add a payment method to prevent your links and data from getting deleted.",
          type: "error"
        },
        restore_artist: { message: null, type: null },
        account_past_due: {
          message: "There was an issue charging the card on file.",
          type: "error"
        }
      },
      billing_intervals: {
        monthly: "Monthly",
        yearly: "Yearly"
      },
      internalActionType: "",
      new_billing_interval: "monthly",
      newPlan: null,
      availablePlans: [
        {
          name: "bio",
          priceMonthly: 6,
          priceYearly: 60,
          features: [
            "Artist Bio Page",
            "Smart Deeplinks",
            "Pixel Integrations",
            "Custom Domains",
            "Advanced Analytics"
          ]
        },
        {
          name: "pro",
          priceMonthly: 19,
          priceYearly: 190,
          features: [
            "Everything in Lite",
            "Single Landing Pages",
            "Album Landing Pages",
            "Playlist Landing Pages"
          ]
        },
        {
          name: "max",
          priceMonthly: 29,
          priceYearly: 290,
          features: [
            "Everything in Pro",
            "1-Click Presave Pro",
            "Release Day Emails",
            "Auto-follow on Spotify"
          ]
        }
      ],
      planNames: {
        bio: "Bio",
        pro: "Pro",
        max: "Max"
      },
      justThisArtist: true,
      braintreeInstance: null,
      defaultPaymentMethod: null,
      cardValid: false,
      braintreeView: null,
      submitting: false,
      subscriptionArtists: []
    };
  },
  apollo: {
    // proPricing: {
    //   query: Q_PRO_PRICING,
    //   variables() {
    //     return {
    //       user_id: this.user.id,
    //     };
    //   },
    //   skip() {
    //     return !this.user;
    //   },
    //   update(data) {
    //     return data.users_by_pk.pro_pricing;
    //   },
    // },
    // maxPricing: {
    //   // TODO:: change this to max pricing
    // }
  },
  computed: {
    mainMessage() {
      return this.mainMessageList[this.internalActionType] || null;
    },
    bannerMessage() {
      return this.bannerMessageList[this.internalActionType]?.message || null;
    },
    bannerType() {
      return this.bannerMessageList[this.internalActionType]?.type || null;
    },
    proPricing() {
      return {
        monthly: 19,
        yearly: 190
      };
    },
    maxPricing() {
      return {
        monthly: 29,
        yearly: 290
      };
    },
    yearly() {
      return this.subscription.billing_interval === "yearly";
    },
    bioPlanPrice() {
      return this.yearly ? 60 : 6;
    },
    proPlanPrice() {
      return this.proPricing;
    },
    maxPlanPrice() {
      return this.maxPricing;
    },
    interval() {
      return this.yearly ? "yr" : "mo";
    },
    prorationAmount() {
      if (["agency", "family"].includes(this.user.plan)) return "";
      if (!this.subscription.status) return "";
      if (this.subscription.status === "Pending") return "";
      if (!this.subscription.last_billing_date) return "";
      if (this.artist.active_plan.includes("pro")) return "";

      const start = moment(this.subscription.last_billing_date, "YYYY-MM-DD");
      const end = moment(this.subscription.next_billing_date, "YYYY-MM-DD");
      const today = moment();

      const proratedDays = end.diff(today, "days") + 1;

      const billingCycle = end.diff(start, "days");

      const total = this.proPlanPrice - this.subscription.discount;
      const dailyRate = total / billingCycle;

      return (dailyRate * proratedDays).toFixed(2);
    },
    totalAmount() {
      if (this.justThisArtist)
        return this.new_billing_interval == "yearly"
          ? this.totalForThisArtist.yearly
          : this.totalForThisArtist.monthly;
      else
        return this.new_billing_interval == "yearly"
          ? this.total.yearly
          : this.total.monthly;
    },
    yearlyDiscount() {
      return (this.totalForThisArtist.monthly * 2).toFixed(2);
    },
    addOnsQuantity() {
      const res = {
        bio:
          this.subscription?.add_ons?.bio?.quantity ??
          this.artists?.filter(x => x.active_plan === "bio").length ??
          0,
        pro:
          this.subscription?.add_ons?.pro?.quantity ??
          this.artists?.filter(x => x.active_plan === "pro").length ??
          0,
        max:
          this.subscription?.add_ons?.max?.quantity ??
          this.artists?.filter(x => x.active_plan === "max").length ??
          0
      };
      // console.log(res, this.subscription, this.artists);
      return res;
    },
    nextBillingDate() {
      if (this.subscription.next_billing_date) {
        return moment(this.subscription.next_billing_date).format(
          "MMM D, YYYY"
        );
      }
      return null;
    },
    currentArtistAddOnsQuantity() {
      const res = {
        bio: this.artist.current_plan == "bio" ? 1 : 0,
        pro: this.artist.current_plan == "pro" ? 1 : 0,
        max: this.artist.current_plan == "max" ? 1 : 0
      };
      // console.log(res, this.subscription, this.artists);
      return res;
    },
    total() {
      const res = {
        monthly:
          this.addOnsQuantity.bio * 6 +
          this.addOnsQuantity.pro * this.proPlanPrice.monthly +
          this.addOnsQuantity.max * this.maxPlanPrice.monthly,
        yearly:
          this.addOnsQuantity.bio * 60 +
          this.addOnsQuantity.pro * this.proPlanPrice.yearly +
          this.addOnsQuantity.max * this.maxPlanPrice.yearly
      };
      return res;
    },
    totalForThisArtist() {
      const res = {
        monthly:
          this.currentArtistAddOnsQuantity.bio * 9 +
          this.currentArtistAddOnsQuantity.pro * this.proPlanPrice.monthly +
          this.currentArtistAddOnsQuantity.max * this.maxPlanPrice.monthly,
        yearly:
          this.currentArtistAddOnsQuantity.bio * 90 +
          this.currentArtistAddOnsQuantity.pro * this.proPlanPrice.yearly +
          this.currentArtistAddOnsQuantity.max * this.maxPlanPrice.yearly
      };
      return res;
    },
    artists() {
      return this.user.artists;
    },
    planUpdated() {
      return (
        (this.newPlan && this.newPlan != this.artist.active_plan) ||
        this.new_billing_interval != this.subscription.billing_interval
      );
    },
    isAgency() {
      return this.user.plan === "agency";
    },
    isFamily() {
      return this.user.plan === "family";
    },
    paymentButtonDisabled() {
      if (this.braintreeView === "card" && !this.cardValid) return true;
      if (this.newPlan === this.artist.active_plan) return true;
      return !this.braintreeInstance;
    }
  },
  components: { ChevronDownIcon },
  mounted() {
    if (!this.subscription.status || this.subscription.status === "Canceled") {
      return;
    } else {
      this.$emit("close", false);
    }

    this.internalActionType = this.actionType || "activate_sub";
    this.newPlan = this.artist.active_plan;
  },
  async created() {
    // if (this.isAgency || this.isFamily)
    //   return this.$router.push({ name: "settings" });

    const result = await this.$apollo.mutate({
      client: "localClient",
      mutation: M_BRAINTREE_CLIENT_TOKEN
    });

    this.$nextTick(() => {
      const options = {
        authorization: result.data.braintree_client_token.token,
        selector: "#dropin-container-updated",
        defaultFirst: true,
        card: {
          cvv: {
            required: true
          },
          overrides: {
            styles: {
              input: {
                color: "white"
              },
              ":focus": {
                color: "white"
              }
            },
            fields: {
              number: {
                placeholder: "1234 1234 1234 1234"
              }
            }
          }
        }
      };

      dropin.create(options, (error, instance) => {
        if (error) {
          console.error(error);
          return;
        }

        this.braintreeInstance = instance;
        this.defaultPaymentMethod = this.braintreeInstance?._model?._activePaymentMethod?.nonce;

        this.braintreeInstance.on("changeActiveView", event => {
          this.braintreeView = event.newViewId;
        });

        this.braintreeInstance.on("card:validityChange", event => {
          this.cardValid = Object.values(event.fields).every(x => x.isValid);
        });
      });
    });
    if (!this.artist.current_plan) this.selectPlan("pro");
  },
  filters: {
    getArtistPlan(artist, subscription) {
      const current = artist.current_plan.split("_")[0];
      const active = artist.active_plan.split("_")[0];

      return current === active
        ? this.planNames[active]
        : `${this.planNames[active]} (${this.planNames[current]} until ${subscription.next_billing_date})`;
    },
    formatDate(date) {
      return moment(date).format("MMMM Do, YYYY");
    }
  },
  methods: {
    getAlertText(planId, billingInterval) {
      const { name, active_plan } = this.artist;
      const plan = this.planNames[planId];

      if (active_plan === "")
        return (
          "You are starting a " +
          plan +
          " subscription for " +
          name +
          ", to be billed " +
          billingInterval +
          "."
        );

      if (!planId) return "You are cancelling " + name + "'s subscription.";

      return `
        You are
        <strong style="color: #BE3BFF">${this.getPlanChangeStatus(
          this.artist.active_plan,
          planId
        )}</strong> ${name}'s
        subscription to a <strong style="color: #BE3BFF">${plan}</strong> plan, to be billed <strong style="color: #BE3BFF">${billingInterval}</strong>.
      `;
    },
    getPlanChangeStatus(currentPlan, newPlan) {
      const plans = Object.keys(this.planNames);

      const currentPlanIndex = plans.indexOf(currentPlan);
      const newPlanIndex = plans.indexOf(newPlan);

      if (newPlanIndex > currentPlanIndex) {
        return "upgrading";
      } else if (newPlanIndex < currentPlanIndex) {
        return "downgrading";
      } else {
        return "staying on";
      }
    },
    async updateArtistPlan(plan) {
      try {
        if (this.submitting) return;
        this.submitting = true;
        const alert = {
          title: `Are you sure?`,
          html: `<p class="description">${this.getAlertText(
            plan,
            this.new_billing_interval
          )}</p>
          <p class="description">You will be charged <strong style="color: #BE3BFF">$${
            this.totalAmount
          }</strong>.</p>
          `,
          type: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "<span>Confirm</span>",
          cancelButtonText: "<span>Cancel</span>",
          confirmButtonClass: "button-secondary",
          cancelButtonClass: "button-danger",
          buttonsStyling: false,
          reverseButtons: true
        };

        // if (plan === "pro") {
        //   alert.reverseButtons = true;
        //   alert.confirmButtonText = "<span>Confirm</span>";
        //   alert.confirmButtonClass = "button-default big";
        //   alert.cancelButtonClass = "button-danger big";

        //   if (this.artist.active_plan !== "" && this.prorationAmount > 0) {
        //     alert.title = "Confirm Prorated Charge";
        //     alert.html = `
        //     <p class="description">You’ll be charged
        //     $${this.prorationAmount}
        //     now instead of the full ${
        //       this.yearly ? "yearly" : "monthly"
        //     } rate.</p>`;
        //   }
        // }

        const confirmUpdate = await Swal.fire(alert);

        if (!confirmUpdate.value) return;

        // if (this.subscribing) {
        //   return this.planSelected({
        //     id: this.artist.id,
        //     selected_plan: plan,
        //   });
        // } else {
        //       selected_plan: String!
        // id: String
        // name: String
        this.subscriptionArtists = [
          { id: this.artist.id, selected_plan: plan, name: this.artist.name }
        ];

        let nonce = null;
        if (this.braintreeInstance) {
          this.braintreeInstance.requestPaymentMethod(async (err, payload) => {
            if (err) return console.error(err);
            nonce = payload.nonce;
            if (!nonce) return;

            this.submitting = true;
            let response = await this.$apollo.mutate({
              client: "localClient",
              mutation: M_BRAINTREE_SUBSCRIBE,
              variables: {
                braintree_nonce: nonce,
                yearly_plan: this.new_billing_interval == "yearly",
                artists: this.subscriptionArtists
              }
            });

            const { user } = response.data.braintree_subscribe;
            this.$store.commit("setUser", user);
            this.defaultPaymentMethod = nonce;
            this.submitting = false;
            return this.$emit("close", true, !!user);
          });
        }

        // console.log(nonce);

        // this.submitting = plan || "cancelling";
        // let success = false;

        // let response = await this.$apollo.mutate({
        //   client: "localClient",
        //   mutation: M_BRAINTREE_CHANGE_ARTIST_PLAN,
        //   variables: {
        //     artist_id: this.artist.id,
        //     selected_plan: plan,
        //   },
        // });

        // success = response.data.braintree_change_artist_plan.success;
        // console.log(
        //   response.data.braintree_change_artist_plan,
        //   "braintree_change_artist_plan"
        // );

        // console.log(success);

        // return this.$emit("close", true, success);
        // }
      } catch (err) {
        this.submitting = false;
        console.log(err);
        return this.$emit(
          "close",
          true,
          false,
          `Oops! ${err.message.replace("GraphQL error: ", "")}`
        );
      }
    },
    async planSelected(artist) {
      this.subscriptionArtists = [artist];
      return this.onSuccessBillingUpdate();
    },
    async onSuccessBillingUpdate() {
      return this.braintreeInstance.requestPaymentMethod(
        async (err, payload) => {
          if (err) return console.error(err);

          let nonce = payload.nonce;
          if (!nonce) return;

          this.submitting = true;
          let response = await this.$apollo.mutate({
            client: "localClient",
            mutation: M_BRAINTREE_SUBSCRIBE,
            variables: {
              braintree_nonce: nonce,
              yearly_plan: false,
              artists: this.subscriptionArtists
            }
          });

          const { user } = response.data.braintree_subscribe;
          this.$store.commit("setUser", user);
          this.defaultPaymentMethod = nonce;
          this.submitting = false;

          return this.$emit("close", true, true);
        }
      );
    },
    async updateBillingInterval(interval) {
      try {
        this.submitting = true;
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_BRAINTREE_CHANGE_BILLING_INTERVAL,
          variables: {
            yearly_plan: interval === "yearly"
          }
        });

        const { success } = response.data.braintree_change_billing_interval;

        this.submitting = false;

        if (success) {
          await this.$store.dispatch("setBillingInterval", interval);
          return this.$apollo.queries.billing_information.refetch();
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`
          });
        }
      } catch (err) {
        console.log(err);
        this.submitting = false;
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      }
    },

    updatePlan() {},
    selectPlan(plan) {
      this.newPlan = plan;
      this.artist.current_plan = plan;
    }
  },
  watch: {
    artist: {
      deep: true,
      handler() {
        if (!this.artist.current_plan) this.selectPlan("pro");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap");

.content {
  //   background: #1b193c;
  .back-container {
    button {
      cursor: pointer;
      display: flex;
      align-items: center;
      //max-width: fit-content;
      border: none;
      background: $bg-type-2;
      border-radius: 5px;
      padding: 6px;
      /* 12/SemiBold */
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      /* Text/type0 */
      color: $text-type-0;

      &:hover {
        color: white;
        background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);
      }

      svg {
        margin-right: 10px;
        transform: rotate(90deg);
        width: 14px;

        path {
          stroke: white;
        }
      }
    }
  }

  .billing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .artist {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .avatar {
        img {
          height: 90px;
          width: 90px;
          border-radius: 50%;
        }
      }

      .name {
        margin-top: 15px;
        color: #ffffff;
        font-weight: 700;
        font-size: 30px;
      }
    }

    .selected-plan {
      margin-top: 40px;
      background-color: $bg-type-2;
      padding: 15px;
      border-radius: 5px;
      width: 630px;
      display: flex;

      span {
        font-size: 16px;
        font-weight: 600;
        color: $text-type-0;

        &.plan {
          color: #ffffff;
          margin-left: 10px;
        }

        &.cancel {
          color: #9c27b0;
          cursor: pointer;
          margin-left: auto;
        }
      }
    }

    .plans {
      margin-top: 40px;
      display: flex;

      .plan {
        display: flex;
        flex-direction: column;
        background-color: #09091b;
        box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
        padding: 24px;
        margin: 0 15px;
        width: 300px;
        border-radius: 10px;

        &.current {
          background: linear-gradient(
            241.25deg,
            rgba(41, 39, 85, 0.45) 4.4%,
            rgba(41, 39, 84, 0.85) 61.77%,
            rgba(27, 24, 66, 0.45) 119.94%
          );
          box-shadow: 0px 51px 69px rgba(23, 18, 43, 0.585739);
        }

        .top {
          display: flex;
          justify-content: space-between;

          .name {
            color: #ffffff;
            font-weight: 700;
            font-size: 18px;
          }

          .current {
            background: #ffffff;
            border-radius: 50px;
            color: #9b51e0;
            font-size: 12px;
            padding: 3px 10px 0;
          }
        }

        .price {
          margin-top: 20px;

          .amount {
            font-weight: 700;
            font-size: 30px;
            color: #ffffff;
          }

          .per {
            font-weight: 400;
            font-size: 30px;
            color: #b1afcd;
          }
        }

        .separator {
          height: 1px;
          background-color: #24224a;
          margin: 15px 0;
        }

        .features {
          margin-bottom: 30px;

          .feature {
            display: flex;
            margin: 12px 0;

            .is-included {
              margin-top: -1px;

              svg {
                width: 15px;
                height: 15px;
                display: block;

                path {
                  fill: white;
                }
              }
            }

            .description {
              margin-left: 5px;
              font-weight: 600;
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .action {
          display: flex;
          justify-content: center;
          margin-top: auto;
        }
      }
    }

    .card-content {
      // width: 630px;
      margin-top: 10px;
      display: grid;
      grid-gap: 24px;

      .payment-container {
        width: 100%;

        .payment-footer {
          padding-top: 10px;
          display: flex;

          button {
            margin-left: auto;
          }
        }
      }

      .braintree-billing {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .payment {
          width: 100%;

          .button-default {
            //margin-top: -44px;
            padding: 9px 30px;
            float: right;
          }
        }
      }
    }
  }
}

.banner-alert {
  flex: 1;
  display: flex;
  width: 100%;
  background: #24224a;
  border: 1px solid #fff;
  color: white;
  border-radius: 10px;
  padding: 20px 24px;

  margin-bottom: 48px;

  .text {
    display: flex;
    flex-direction: column;
    padding-right: 30px;

    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 26px;
      color: #ffffff;

      i {
        margin-right: 5px;
      }
    }

    .details {
      margin-top: 5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex: 1;

    button {
      white-space: nowrap;
    }
  }

  &--error {
    background: #ff0000;
    border: 1px solid #ff0000;
    box-shadow: 0px 50px 40px 0px rgba(23, 18, 43, 0.3);
  }
}

.billing-card {
  width: 100%;
  background-color: #24224a;
  border-radius: 10px;
  box-shadow: 0px 50px 40px 0px rgba(23, 18, 43, 0.3);
  padding: 72px 120px;

  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: #ffffff;
      mix-blend-mode: normal;
      opacity: 0.9;
    }

    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: #b1afcd;
      mix-blend-mode: normal;
      opacity: 0.9;

      .bold {
        font-weight: 600;
        //color: white;
      }
    }

    &.card-information {
      display: flex;
      justify-content: center;
      align-items: center;

      .brands {
        margin-left: auto;
        display: flex;
        gap: 20px;
      }
    }
  }

  .card-content {
    display: grid;
    grid-gap: 24px;

    .payment-container {
      width: 100%;

      .payment-footer {
        padding-top: 10px;
        display: flex;

        button {
          margin-left: auto;
        }
      }
    }

    .braintree-billing {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .payment {
        width: 100%;

        .button-default {
          //margin-top: -44px;
          padding: 9px 30px;
          float: right;
        }
      }
    }
  }
}

.billing-interval {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .element {
    display: flex;
    flex-direction: column;
    background: $bg-type-1;
    align-items: center;
    border-radius: 10px;
    padding: 20px 0px;
    border: 1px solid white;
    flex: 1;

    &.selected {
      border: 1px solid #be3bff;
    }

    &:hover {
      cursor: pointer;
    }

    .title {
      /* 16/SemiBold */
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }

    .subtitle {
      /* 12/Regular */
      font-size: 14px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }

  &.trial {
    justify-content: space-between;

    .element {
      width: 47.5%;
    }
  }
}

.plan-selector {
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
  background: $bg-type-1;
  align-items: center;
  border-radius: 10px;
  padding: 40px 0px;
  font-family: "Montserrat", "Open Sans", "Helvetica Neue Light",
    "Helvetica Neue", "Helvetica", "Arial";
  // padding: 20px 0px;
  flex: 1;

  &.selected {
    border: 1px solid #be3bff;
  }

  &:hover {
    cursor: pointer;
  }

  .title {
    /* 16/SemiBold */
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* White */
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .subtitle {
    /* 12/Regular */
    font-size: 14px;
    /* Text/type0 */
    color: $text-type-0;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
}
</style>
